import DeleteForever from "@mui/icons-material/DeleteForever";
import { useEffect, useState } from "react"
import CustomButtonSimple from "../../../components/CustomMiscellaneous/CustomButtonSimple";
import { CustomInput } from ".."
import HorizontalRule from "../../../components/HorizontalRule/HorizontalRule"
import AddIcon from '@mui/icons-material/Add';
import { palette } from "../../../assets/theme/theme";
import { useLocation } from "react-router-dom";
import { PropConfig } from "../../../types/EntityConfig";
import { useFormType } from "../../hooks/useForm";

export const CustomMultipleInput = ({ label, onChange, value, inputConfig, form, parentIndex, key }: { key: string, label: string | undefined, onChange: Function, value: any, inputConfig: PropConfig, form?: useFormType, parentIndex?: number }) => {

    console.log("Value -----------------------------> ", value);

    const location = useLocation();
    const currentRoute = location.pathname;

    const [instances, setInstances] = useState<any[]>([]);

    const [collapsedIndexes, setCollapsedIndexes] = useState<number[]>([]);

    useEffect(() => {
        console.log("COllapsed items: ", collapsedIndexes);
    }, [collapsedIndexes])

    const handleCollapsedIndexes = (index: number) => {
        console.log("Index is: ", index);
        console.log("Included? ", collapsedIndexes.includes(index));
        if (collapsedIndexes.includes(index)) {
            console.log("Filtering: ", collapsedIndexes);
            setCollapsedIndexes(collapsedIndexes.filter(ci => ci !== index));
            return;
        }
        setCollapsedIndexes([...collapsedIndexes, index]);

    }


    // TODO add support for other types of triggered getters
    const buildGetterFunction = (tc: any) => {
        if (tc.options?.routeBasedGetter && currentRoute) {
            const routes = tc.options.routeParams.map((rp: any) => currentRoute.split('/')[rp])
            return () => tc.options?.routeBasedGetter(...routes);
        }
        return tc.options?.getter;
    }



    useEffect(() => {
        if (value?.length) {
            let instanceArr: any[] = [];
            value.forEach((v: any) => {
                const dataHandler: any = {};
                inputConfig?.options?.subFormConfig?.filter((o: any) => !o.nonEditable).map((o: any) => {
                    dataHandler[o.id] = v[o.id];
                })
                dataHandler.id = v.id;
                instanceArr.push(dataHandler);
            })

            setInstances([...instanceArr]);
        }
    }, [])


    useEffect(() => {
        console.log("Instances: ", instances);
    }, [instances])



    const incrementInstance = () => {
        const instanceArr = instances;
        const dataHandler: any = {};
        inputConfig?.options?.subFormConfig?.filter((o: any) => !o.nonEditable).map((o: any) => {
            dataHandler[o.id] = null;
        })
        instanceArr.push(dataHandler);
        setInstances([...instanceArr]);
        onChange(instanceArr, inputConfig?.options?.ref, 'multiple-create', null)

    }


    const deleteRow = (idx: number) => {
        const newArr = instances;
        newArr.splice(idx, 1);
        setInstances([...newArr]);
        onChange(newArr, inputConfig?.options?.ref, 'multiple-create', null)
    }


    const updateObject = (e: Event, id: string, idx: number, type: PropConfig['type'], config: PropConfig) => {
        const instanceArr = instances;
       
        const regularTargetValue = bootstrapValue(type, e, config) ;
        instanceArr[idx][id] = regularTargetValue;
        setInstances([...instanceArr])
        onChange(instances, inputConfig?.options?.ref, 'multiple-create', null)
    }

    const bootstrapValue = (type: PropConfig["type"] | undefined, rawValue: any, config: PropConfig) => {
  
        let value;
        if(type=== 'boolean') {
            value = rawValue?.target?rawValue.target.checked : rawValue;
        } else if (type === 'number') {
            value = rawValue?.target? parseFloat(rawValue.target.value) : rawValue;
        } else if (type === 'select') {
            console.log("Setting value: ", rawValue);
            value = rawValue;
        } else if (type === 'multi-select') {
            value = rawValue?.length ?  [...rawValue] : [];
        } else if (type === 'date') {
            value = new Date(rawValue).toISOString().split('T')[0];
        } else if (type == 'multiple-create') {
            value = rawValue? [...rawValue] : [];
        } else if(type == 'text') {
            value = rawValue?.target?.value. length? rawValue.target.value :  '';
        }else {
            value = rawValue?.target? rawValue.target.value :  rawValue;
        }
        return value;
    
    }

    const getNestedValues = (tc: PropConfig ,i: number) => {
        if(inputConfig?.options?.nestPathGetter ) {
            return inputConfig?.options?.nestPathGetter(form, i, parentIndex ? parentIndex : 0) ? inputConfig?.options?.nestPathGetter(form, i, parentIndex ? parentIndex : 0)[tc.id] : form?.state[tc.id]

        }

        return form?.state[tc.id]

    }


    return (
        <div style={{ width: '100%' }}>

            <form>
                {instances.map((instance, i) => {
                    return (<div className="w-full mt-4">
                        <div className="text-lg cursor-pointer w-fit" onClick={() => handleCollapsedIndexes(i)}> {label} {i + 1} </div>

                        {collapsedIndexes.includes(i) ? <div>
                            <div>Displaying info</div>
                        </div> : null}
                            <div key={i} className={`border rounded p-5 mt-2 border-rodrimaq-red-light ${collapsedIndexes.includes(i) ? 'hidden': 'block'}`}>
                                <div className="flex items-center">
                                {inputConfig?.options?.subFormConfig?.filter((tc: any) => !tc.nonEditable)
                                .filter((tc: PropConfig) => tc.type != 'multiple-create')
                                .filter((tc: PropConfig) => tc.conditional ? tc.conditional(form, parentIndex, i) : true)
                                .map((tc: PropConfig, idx: number) => {
                                    return (
                                        <div key={idx} className="w-full">
                                            <CustomInput
                                                inputConfiguration={tc}
                                                getter={buildGetterFunction(tc)}
                                                customOnChange={(e: Event) => updateObject(e, tc.id, i, tc.type, tc)}
                                                form={form}
                                                isSubForm={true}
                                                valueGetter={()=>getNestedValues(tc, i)}
                                                parentIndex={i}
                                            />

                                        </div>) 
                                })}
                                </div>

                                <div>
                                    <div>
                                    {inputConfig?.options?.subFormConfig?.filter((tc: any) => !tc.nonEditable)
                                    .filter((tc: PropConfig) => tc.type == 'multiple-create')
                                    .map((tc: PropConfig, idx: number) => {
                                        return (
                                            <div key={idx} className="w-full">

                                                <CustomInput
                                                    inputConfiguration={tc}
                                                    getter={buildGetterFunction(tc)}
                                                    customOnChange={(e: Event) => updateObject(e, tc.id, i, tc.type, tc)}
                                                    form={form}
                                                    isSubForm={true}
                                                    valueGetter={()=>getNestedValues(tc, i)}
                                                    parentIndex={i}
                                                />

                                            </div>) 
                                    })}
                                    </div>

                                </div>
                                <div className="flex text-rodrimaq-red cursor-pointer border border-rodrimaq-red rounded w-fit p-1 items-center" onClick={() => deleteRow(i)}>
                                    Eliminar {label} {i + 1}

                                    <DeleteForever className="ml-2"/>

                                </div>
                            </div>
                        


                        <HorizontalRule />

                    </div>
                    )

                })}


            </form>
            <div style={{ marginLeft: 50, marginTop: 40, display: 'flex', justifyContent: 'space-between', fontSize: '0.7em' }}>
                <div >
                </div>
                <CustomButtonSimple text={`Adicionar ${label}`} color={palette.blue.light} onClick={() => incrementInstance()} Icon={AddIcon} />
            </div>
        </div>
    )
}